"use strict";

import { schedulePaymentsConstants } from "../_constants";

const INITIAL_SCHEDULE_PAYMENTS_DATA_STATE = {
  schedulePaymentsList: {
    [schedulePaymentsConstants.TAB_TYPE_ALL]: [],
    [schedulePaymentsConstants.TAB_TYPE_FUND_TRANSFER]: [],
    [schedulePaymentsConstants.TAB_TYPE_BILL_PAYMENT]: [],
  },

  listType: schedulePaymentsConstants.TAB_TYPE_ALL,
  filterPaymentStatus: schedulePaymentsConstants.LIST_STATUS_ACTIVE,

  activeView: null,
  listPageStart: 0,
  listPageEnd: 9,
  /** Whether another page may exist (derived from last response batch vs requested page size). */
  listHasMore: true,
  isListLoading: false,
  schedulePaymentsDetails: null,

  scheduleIterationsData: null,
  isIterationListLoading: false,
  iterationListError: null,

  selectedIterationData: null,
  isChangeIterationStatusLoading: false,
  changeIterationStatusError: null,
  changeIterationStatusSuccess: false,

  isStopSchedulePaymentLoading: false,

  isSchedulePaymentStopSuccess: false,

  navigateFrom: null,

  scheduleDetailActiveTab:
    schedulePaymentsConstants.SCHEDULE_DETAIL_TAB_UPCOMING_SCHEDULES,
};

export function schedulePaymentsReducer(
  state = INITIAL_SCHEDULE_PAYMENTS_DATA_STATE,
  action,
) {
  switch (action.type) {
    case schedulePaymentsConstants.SET_ACTIVE_VIEW:
      return {
        ...state,
        activeView: action.payload,
      };

    case schedulePaymentsConstants.SCHEDULE_PAYMENTS_LIST_REQUEST: {
      // We store the active list tab into `listType` so the COMPLETE action knows where to put results. // `activeView` controls list-vs-summary screen; `action.payload.type` controls tab grouping.
      const listType =
        action.payload?.type || schedulePaymentsConstants.TAB_TYPE_ALL;
      const requestedPageStart = action.payload?.pageStart ?? 0;
      const shouldResetList = requestedPageStart === 0;
      return {
        ...state,
        listType,
        schedulePaymentsList: {
          ...state.schedulePaymentsList,
          [listType]: shouldResetList
            ? []
            : state.schedulePaymentsList[listType] || [],
        },
        listPageStart: requestedPageStart,
        listPageEnd: action.payload?.pageEnd,
        listHasMore: true,
        isListLoading: true,
      };
    }

    case schedulePaymentsConstants.SCHEDULE_PAYMENTS_LIST_COMPLETE: {
      const completeListType =
        state.listType || schedulePaymentsConstants.TAB_TYPE_ALL;
      const incomingList =
        action.payload?.data?.onetimeSchedulePaymentDto || [];
      const list = Array.isArray(incomingList) ? incomingList : [];
      const pageStart = state.listPageStart ?? 0;
      const pageEnd = state.listPageEnd ?? 9;
      const pageSpan = Math.max(1, pageEnd - pageStart + 1);
      const listHasMore = list.length >= pageSpan;
      return {
        ...state,
        schedulePaymentsList: {
          ...state.schedulePaymentsList,
          [completeListType]:
            state.listPageStart !== 0
              ? [
                  ...(state.schedulePaymentsList[completeListType] || []),
                  ...list,
                ]
              : list,
        },
        listHasMore,
        isListLoading: false,
      };
    }

    case schedulePaymentsConstants.SCHEDULE_PAYMENTS_LIST_ERROR: {
      const errorListType =
        state.listType || schedulePaymentsConstants.TAB_TYPE_ALL;
      return {
        ...state,
        schedulePaymentsList: {
          ...state.schedulePaymentsList,
          [errorListType]: [
            ...(state.schedulePaymentsList[errorListType] || []),
          ],
        },
        listPageStart: Math.max(0, (state.listPageStart || 0) - 10),
        listPageEnd: Math.max(0, (state.listPageEnd || 0) - 10),
        listHasMore: true,
        isListLoading: false,
      };
    }

    case schedulePaymentsConstants.SET_SCHEDULE_PAYMENTS_DETAILS:
      return {
        ...state,
        schedulePaymentsDetails: action.payload,
      };

    case schedulePaymentsConstants.CHANGE_ITERATION_STATUS_REQUEST:
      return {
        ...state,
        isChangeIterationStatusLoading: true,
        changeIterationStatusError: null,
        changeIterationStatusSuccess: false,
      };

    case schedulePaymentsConstants.CHANGE_ITERATION_STATUS_COMPLETE: {
      return {
        ...state,
        isChangeIterationStatusLoading: false,
        changeIterationStatusSuccess: true,
        changeIterationStatusError: null,
      };
    }

    case schedulePaymentsConstants.CHANGE_ITERATION_STATUS_ERROR:
      return {
        ...state,
        isChangeIterationStatusLoading: false,
        changeIterationStatusError: action.payload,
        changeIterationStatusSuccess: false,
        changeIterationStatusSuccess: false,
      };

    case schedulePaymentsConstants.SCHEDULE_ITERATION_LIST_REQUEST:
      return {
        ...state,
        isIterationListLoading: true,
        iterationListError: null,
        scheduleIterationsData: null,
      };

    case schedulePaymentsConstants.SCHEDULE_ITERATION_LIST_COMPLETE: {
      return {
        ...state,
        isIterationListLoading: false,
        iterationListError: null,
        scheduleIterationsData: action.payload?.data?.iterations,
      };
    }

    case schedulePaymentsConstants.SCHEDULE_ITERATION_LIST_ERROR:
      return {
        ...state,
        isIterationListLoading: false,
        iterationListError: action.payload,
        scheduleIterationsData: null,
      };

    case schedulePaymentsConstants.STOP_SCHEDULE_PAYMENT_REQUEST:
      return {
        ...state,
        isStopSchedulePaymentLoading: true,
        isSchedulePaymentStopSuccess: false,
      };

    case schedulePaymentsConstants.STOP_SCHEDULE_PAYMENT_COMPLETE: {
      return {
        ...state,
        isStopSchedulePaymentLoading: false,
        isSchedulePaymentStopSuccess: true,
        activeView:
          schedulePaymentsConstants.ACTIVE_VIEW_SCHEDULE_PAYMENT_STOP_SUCCESS,
      };
    }

    case schedulePaymentsConstants.STOP_SCHEDULE_PAYMENT_ERROR:
      return {
        ...state,
        isStopSchedulePaymentLoading: false,
        isSchedulePaymentStopSuccess: true,
      };

    case schedulePaymentsConstants.CLEAR_STOP_SCHEDULE_PAYMENT_CLOSE_MODAL:
      return {
        ...state,
        isSchedulePaymentStopSuccess: false,
      };

    case schedulePaymentsConstants.SET_SELECTED_SCHEDULE_PAYMENTS_ITERATION_DETAILS:
      return {
        ...state,
        selectedIterationData: action.payload,
      };

    case schedulePaymentsConstants.SET_NAVIGATE_FROM:
      return {
        ...state,
        navigateFrom: action.payload,
      };

    case schedulePaymentsConstants.CLEAR_STATE:
      let tempNavigateFrom = state.navigateFrom;
      return {
        ...state,
        ...INITIAL_SCHEDULE_PAYMENTS_DATA_STATE,
        navigateFrom: tempNavigateFrom,
      };

    case schedulePaymentsConstants.CLEAR_NAVIGATE_FROM:
      return {
        ...state,
        navigateFrom: null,
      };

    case schedulePaymentsConstants.CLEAR_CHANGE_ITERATION_STATUS_SUCCESS:
      return {
        ...state,
        changeIterationStatusSuccess: false,
      };

    case schedulePaymentsConstants.SET_ACTIVE_LIST_TYPE:
      return {
        ...state,
        listType: action.payload,
      };

    case schedulePaymentsConstants.SET_FILTER_PAYMENT_STATUS:
      return {
        ...state,
        filterPaymentStatus: action.payload,
      };

    case schedulePaymentsConstants.SET_SCHEDULE_DETAIL_ACTIVE_TAB:
      return {
        ...state,
        scheduleDetailActiveTab: action.payload,
      };
  }

  return state;
}
